import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { defaultMessages } from '@I18n/default';
import { FormattedMessage } from 'react-intl';
import arsenalArmySlice from '@Redux/reducers/arsenal/arsenal-army.slice';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';
import { ArsenalUnit } from '@Models';
import Repeater from '@Utils/Repeater';
import ArsenalArmyUnitExportComponent from './arsenal-army-unit-export.component';
import { shareArsenalArmySelector } from '@Selectors/arsenal/share/share-arsenal-army.selector';

const ArsenalArmyShareComponent: React.FC<ArmyListCloneProps> = (
  {
    army,
    isLoading,
    shareUrl,
    exportTxt,
    cancel,
    copied
  }
) => {
  return (
    <div className="mt-2 text-center">

      <h1><FormattedMessage {...defaultMessages.arsenalArmyShareTitle} /></h1>
      <p><FormattedMessage {...defaultMessages.arsenalArmyShareDescription} /> <strong>{army?.name}</strong> ?</p>

      {!isLoading && army &&
        (
          <>
            <div className="w-75 m-auto">
              <div className="m-3 input-group">
                <input type="text" readOnly className="form-control" value={shareUrl} />
                <div className="input-group-btn m-1">
                  <CopyToClipboard text={shareUrl} onCopy={() => copied()}>
                    <button className="btn btn-age"><i className="fa actions fa-copy" /> Copy to clipboard</button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
            <div className="w-75 m-auto">
              <div className="m-3 input-group">
                <table className="w-75">
                  <Repeater data={army.units} indexPrefix='unit'>
                    {
                      (item: ArsenalUnit) => <ArsenalArmyUnitExportComponent unit={item}/>
                    }
                  </Repeater>
                </table>
                <div className="input-group-btn">
                  <CopyToClipboard text={exportTxt} onCopy={() => copied()}>
                    <button className="btn btn-age"><i className="fa actions fa-copy" /> Copy to clipboard</button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
            <div className="action">
              <button className="btn btn-age" type="button" onClick={() => cancel()}>
                <FormattedMessage {...defaultMessages.formCancel} /></button>
            </div>
          </>
        )}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  isLoading: state.arsenalArmy.isLoading,
  army: state.arsenalArmy.entity,
  shareUrl: `${window.location.origin}/${document.documentElement.lang}/arsenal/shares/${state.arsenalArmy.id}/army`,
  exportTxt: shareArsenalArmySelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  cancel: () => dispatch(arsenalArmySlice.actions.cancel()),
  copied: () => {
    toast.success('Copied!');
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalArmyShareComponent);

type ArmyListCloneProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
